<script setup lang="ts">
import tailwindConfig from '@b2b-platform/base/tailwind.config';
import type { DataCell } from '@b2b-platform/commerce/components/Comm/Base/TableRow.vue';
import resolveConfig from 'tailwindcss/resolveConfig';

defineProps({
    initiallyOpen: {
        default: true,
        type: Boolean,
    },
    rows: {
        required: true,
        type: Array as () => {
            description?: string;
            data: DataCell[];
            title: string; // TODO: rename!
        }[],
    },
    title: {
        default: null,
        type: String,
    },
});

const fullConfig = resolveConfig(tailwindConfig as any);
const isLargeDevice = useMatchMedia(
    `(min-width: ${fullConfig.theme.screens.lg})`,
);
</script>

<template>
    <CommBaseCollapse
        v-if="title"
        class="col-span-full grid grid-cols-subgrid"
        trigger-classes="col-span-full"
        panel-classes="col-span-full grid grid-cols-subgrid"
        role="rowgroup"
        :default-open="isLargeDevice"
    >
        <template #trigger>
            <JamBaseText variant="large" class="col-span-full py-5">
                {{ title }}
            </JamBaseText>
        </template>
        <CommBaseTableRow
            v-for="(row, index) in rows"
            :key="index"
            :header="row.title"
            :description="row?.description"
            :class="`grid grid-cols-subgrid col-span-full gap-x-7 py-4 ${
                index > 0 ? 'border-t' : ''
            }`"
            :data="row.data"
        />
    </CommBaseCollapse>
    <template v-else>
        <CommBaseTableRow
            v-for="(row, index) in rows"
            :key="index"
            :header="row.title"
            :description="row?.description"
            :class="`grid grid-cols-subgrid col-span-full gap-x-7 py-4 ${
                index > 0 ? 'border-t' : ''
            }`"
            :data="row.data"
        />
    </template>
</template>
